import React, { ChangeEvent, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

interface Props {
  query?: string | null;
}

/**
 * @description Search component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const Search = (props: Props): JSX.Element => {
  const query = props.query ? props.query : '';
  const nav = useNavigate();
  const [searchQuery, setSearchQuery] = useState<string>(query);

  const onSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      nav(`?q=${e.currentTarget.value}&a=&p=1`);
    }
    return true;
  };

  const onSearchClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    nav(`?q=${searchQuery}&a=&p=1`);
    return true;
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.currentTarget.value);
  };

  return (
    <Form>
      <Form.Group className="text-center" controlId="searchGroup">
        <Row className="justify-content-center">
          <Col md={12} lg={8}>
            <Row className="row bg-white shadow small-screen-no-margin mt-n5 border-radius-lg p-3 pb-4 mx-sm-0 mx-1 position-relative">
              <Col lg={9} className="mt-lg-n2 mt-2 pt-3">
                <Form.Control
                  name="search"
                  value={searchQuery}
                  placeholder={'Search by name or description'}
                  onKeyPress={onSearch}
                  onChange={onChange}
                />
              </Col>
              <Col lg={3} className="mt-lg-n2 mt-2 pt-3">
                <span className="input-group-text-parent element-last">
                  <Button
                    className="search w-100 mb-0"
                    type="submit"
                    variant="primary"
                    onClick={onSearchClick}
                  >
                    Search
                  </Button>
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2 mb2 pt-2 pb-2">
          <Col>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSearchQuery('');
                nav(`?q=&a=&p=1`);
              }}
            >
              <small className="text-primary">clear search and filters</small>
            </a>
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );
};

export default Search;
